import { render } from "./DetalharProspeccao.vue?vue&type=template&id=7c8fbd31&scoped=true"
import script from "./DetalharProspeccao.vue?vue&type=script&lang=js"
export * from "./DetalharProspeccao.vue?vue&type=script&lang=js"

import "./DetalharProspeccao.vue?vue&type=style&index=0&id=7c8fbd31&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c8fbd31"]])

export default __exports__